import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationBlockedVisitors } from "../shared/data.service";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { BlockedExceptionUpdateRequest } from "../shared/BlockedExceptionUpdateRequest";

@Component({
	selector: "app-ms-visitor-blocked-exceptions",
	templateUrl: "./ms-visitor-blocked-exceptions.component.html",
	styleUrls: ["./ms-visitor-blocked-exceptions.component.css"],
})
export class MsVisitorBlockedExceptionsComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private confirmationService: ConfirmationService,
		private visitorService: DataService_MultiStationBlockedVisitors,
		private ref: DynamicDialogRef
	) {}

	ngOnInit(): void {
		this.PersonID = this.dialogConfig.data.PersonID;

		this.PersonName = String(this.dialogConfig.data.FirstName) + " " + String(this.dialogConfig.data.LastName);
		this.PersonName = this.PersonName.trim();

		this.loadFacility();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	PersonID: number = -1;
	PersonName: string = "";

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	Processing: any = false;
	errorMessage: any = "";
	lstFacility: any = [];
	lstIsSelectedDesc: any = [];

	//Cols
	cols: any = [
		{ field: "FacilityCD", header: "Code" },
		{ field: "FacilityName", header: "Facility" },
	];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadFacility() {
		this.loading = true;

		var result = this.visitorService.BlockedExceptionSelectList(this.PersonID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				this.onUpdateFilters();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onUpdateCheck(Facility) {
		if (this.IsLoading() == true) {
			return;
		}

		Facility.IsSelected = !Facility.IsSelected;

		if (Facility.IsSelected == true) {
			Facility.IsSelectedDesc = "Yes";
		} else {
			Facility.IsSelectedDesc = "No";
		}

		this.onUpdateFilters();
	}

	onUpdateFilters() {
		this.lstIsSelectedDesc = Array.from(new Set(this.lstFacility.map((item: any) => item.IsSelectedDesc))).sort();
	}

	onUpdateAll(val) {
		for (var z = 0; z < this.lstFacility.length; z++) {
			var next = this.lstFacility[z];

			next.IsSelected = val;
			if (val == true) {
				next.IsSelectedDesc = "Yes";
			} else {
				next.IsSelectedDesc = "No";
			}
		}

		this.onUpdateFilters();
	}

	onUpdate() {
		this.errorMessage = "";

		var AllowCount = 0;
		for (var z = 0; z < this.lstFacility.length; z++) {
			var next = this.lstFacility[z];

			if (next.IsSelected == true) {
				AllowCount++;
			}
		}

		this.confirmationService.confirm({
			key: "confirmexception",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: this.PersonName + " will now be allowed in " + AllowCount + " facilities even if they are on the block list. Do you want to continue?",
			header: "Success",
			icon: "fa",
			accept: () => {
				this.onFinishUpdate();
			},
		});
	}

	onFinishUpdate() {
		this.Processing = true;

		var fIDs: number[] = [];

		for (var z = 0; z < this.lstFacility.length; z++) {
			var next = this.lstFacility[z];

			if (next.IsSelected == true) {
				fIDs = [...fIDs, next.FacilityID];
			}
		}

		var parms: BlockedExceptionUpdateRequest = {
			PersonID: this.PersonID,
			lstFacilityID: fIDs,
		};

		var result = this.visitorService.BlockedExceptionUpdate(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "exceptionresult",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Blocked Exceptions were updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "exceptionresult",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the visitor's blocked exceptions: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	////////////////////////////////////////////
}
